export enum BasculeHoganFiservEnum {
  HOGAN = 'HOGAN',
  FISERV = 'FISERV',
}
export default BasculeHoganFiservEnum;
